import moment from "moment";
import { useTranslation } from "react-i18next";
import BandTag from "./BandTag";
import peopleNouns from "./peopleNouns";

const ExpiringPassesTable = ({
  passes = [],
  horizonDays = 30,
  context,
  controls = null,
}) => {
  const { t } = useTranslation("coaching-portal");

  return (
    <>
      <header className="table-header">
        <hgroup>
          <div className="flex items-center gap-2">
            <h3 className="title">
              {t("income.attention.expiringPassesTableTitle", {
                count: horizonDays,
              })}
            </h3>
            <BandTag kind="snapshot" label={t("income.bands.now")} />
          </div>
        </hgroup>
        {controls}
      </header>
      <table role="report-table" className="expiring-passes-table">
        <thead role="table-header">
          <tr>
            <th>{t(peopleNouns(context).column)}</th>
            <th>{t("income.attention.email")}</th>
            <th>{t("income.attention.passType")}</th>
            <th>{t("income.attention.expires")}</th>
            <th className="text-center">{t("income.attention.action")}</th>
          </tr>
        </thead>
        {passes.length > 0 ? (
          <tbody>
            {passes.map((pass) => (
              <tr key={pass.userId}>
                <td>{pass.name || pass.email}</td>
                <td>{pass.email}</td>
                <td>
                  {pass.passType === "week"
                    ? t("income.attention.weekPass")
                    : pass.passType}
                </td>
                <td>{moment(pass.periodEnd).format("MMM D, YYYY")}</td>
                <td className="text-center">
                  {pass.receiptUrl && (
                    <a
                      role="button"
                      target="_blank"
                      rel="noreferrer"
                      href={pass.receiptUrl}
                      data-button-type="secondary"
                    >
                      {t("income.attention.viewReceipt")}
                    </a>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        ) : (
          <tbody>
            <tr>
              <td colSpan="100%">
                <div className="body-table-empty">
                  <p>
                    {t("income.attention.noExpiringPasses", {
                      count: horizonDays,
                    })}
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
        )}
      </table>
    </>
  );
};

export default ExpiringPassesTable;
